import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_edit_or_add_form = _resolveComponent("edit-or-add-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.modalConfig.visible,
    title: _ctx.modalConfig.modalTitle?_ctx.modalConfig.modalTitle:_ctx.editInfo.computedModalTitle,
    onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editInfo.cancel())),
    onOk: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editInfo.submit())),
    width: _ctx.modalConfig.width?_ctx.modalConfig.width+'px':'800px',
    maskClosable: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_edit_or_add_form, {
        form: _ctx.form,
        rules: _ctx.rules,
        "form-config": _ctx.formConfig,
        "layout-config": _ctx.layoutConfig,
        ref: _ctx.editInfo.getForm
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["form", "rules", "form-config", "layout-config"])
    ]),
    _: 3
  }, 8, ["visible", "title", "width"]))
}